import _ from 'lodash';
import { useDeepCompareEffect } from 'react-use';
import defaultImg from '../app/static/images/default.png';
import inspectedMarkerImg from '../app/static/images/inspected.png';
import needInspectionMarkerImg from '../app/static/images/need.png';
import regularTypeMarkerImg from '../app/static/images/regular.png';
import { InspectionScoreListLabel, InspectionStatusList } from '../utils/enum';
import { MarkerClustering } from './MarkerClustering';

export function useFacilityMarkers(map, facilities, onMarkerClicked = _.noop) {
  useDeepCompareEffect(() => {
    const markers: any[] = [];
    let markerClustering;
    if (map && !_.isEmpty(facilities)) {
      for (let facility of facilities) {
        const hoverDivStyle =
          'position: absolute;background: rgba(255, 255, 255);border-radius: 999px;display: none;align-items: center;height: 58px;flex-direction: column; padding-left: 32px;top: 0px;left: 22px;border-top-left-radius: 0px;border-bottom-left-radius: 0px;justify-content: center;align-items: flex-start;padding-right: 12px; min-width:142px;';
        const needInspectionMarkerIcon = {
          content: `
<div class="markerDiv" style="position:relative; transform: scale(0.7);">
   <p style="position:relative; z-index:1;">
      <img style="cursor:pointer;" src="${needInspectionMarkerImg}"/>
      <span style="background: #fff;position: absolute;border-radius: 50%;top: 6px;left: 5px;">
      <img style="cursor:pointer;width:36px;height:36px" src="${
        facility?.iconUrl || defaultImg
      }"/>
      </span>
   </p>
   <div class="infoDiv" style="${hoverDivStyle}">
      <span style="color:#D22259;font-size:14px;font-weight:700;max-width:90px; overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${
        facility?.title || '-'
      }</span>
      <div style="display:flex;flex-direction:row;color:#48464C;font-size:12px;">
         <span style="font-weight:700;">${
           facility?.inspectionScore || '-'
         }</span>
         <span style="font-weight:500">${_.get(
           InspectionScoreListLabel,
           facility?.inspectionScore,
           '-',
         )}</span>
         <span style="color:#938F96;max-width:64px; overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">(${facility?.serialNumber})</span>
      </div>
   </div>
</div>
            `,
          // size: new window.naver.maps.Size(38, 58),
          anchor: new window.naver.maps.Point(23, 58),
        };

        const inspectedMarkerIcon = {
          content: `
<div class="markerDiv" style="position:relative; transform: scale(0.7);">
   <p style="position:relative; z-index:1;">
      <img style="cursor:pointer;" src="${inspectedMarkerImg}"/>
      <span style="background: #fff;position: absolute;border-radius: 50%;top: 6px;left: 5px;">
      <img style="cursor:pointer;width:36px;height:36px" src="${
        facility?.iconUrl || defaultImg
      }"/>
      </span>
   </p>
   <div class="infoDiv" style="${hoverDivStyle}">
      <span style="color:#000;font-size:14px;font-weight:700;max-width:90px; overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${
        facility?.title || '-'
      }</span>
      <div style="display:flex;flex-direction:row;color:#48464C;font-size:12px;">
         <span style="font-weight:700;">${
           facility?.inspectionScore || '-'
         }</span>
         <span style="font-weight:500">${_.get(
           InspectionScoreListLabel,
           facility?.inspectionScore,
           '-',
         )}</span>
         <span style="color:#938F96;max-width:64px; overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">(${facility?.serialNumber})</span>
      </div>
   </div>
</div>
            `,
          // size: new window.naver.maps.Size(38, 58),
          anchor: new window.naver.maps.Point(23, 58),
        };

        const reqularTypeIcon = {
          content: `
<div class="markerDiv" style="position:relative; transform: scale(0.7);">
   <p style="position:relative; z-index:1;">
      <img style="cursor:pointer;" src="${regularTypeMarkerImg}"/>
      <span style="background: #fff;position: absolute;border-radius: 50%;top: 6px;left: 5px;">
      <img style="cursor:pointer;width:36px;height:36px" src="${
        facility?.iconUrl || defaultImg
      }"/>
      </span>
   </p>
   <div class="infoDiv" style="${hoverDivStyle}">
      <span style="color:#000;font-size:14px;font-weight:700;max-width:90px; overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${
        facility?.title || '-'
      }</span>
      <div style="display:flex;flex-direction:row;color:#48464C;font-size:12px;">
         <span style="color:#938F96;max-width:64px; overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">(${facility?.serialNumber})</span>
      </div>
   </div>
</div>
            `,
          // size: new window.naver.maps.Size(38, 58),
          anchor: new window.naver.maps.Point(23, 58),
        };
        const inspectionStatus = facility.inspectionStatus;
        const inspected = inspectionStatus === InspectionStatusList.INSPECTED;
        const regularType =
          inspectionStatus === InspectionStatusList.INSPECTION_NOT_REQUIRED;

        const position = new window.naver.maps.LatLng(
          facility.latitude,
          facility.longitude,
        );

        const marker = new window.naver.maps.Marker({
          position,
          map,
          icon: inspected
            ? inspectedMarkerIcon
            : regularType
            ? reqularTypeIcon
            : needInspectionMarkerIcon,
        });
        markers.push(marker);
        window.naver.maps.Event.addListener(marker, 'click', () =>
          onMarkerClicked(facility),
        );

        const infoDiv = marker.getElement()?.querySelector('.infoDiv');
        const markerDiv = marker.getElement()?.querySelector('.markerDiv');
        if (infoDiv || markerDiv) {
          window.naver.maps.Event.addListener(
            marker,
            'mouseover',
            function (e) {
              infoDiv.style.display = 'flex';
              markerDiv.style.transform = 'scale(1.0)';
              markerDiv.style.zIndex = '100';
            },
          );

          window.naver.maps.Event.addListener(marker, 'mouseout', function (e) {
            infoDiv.style.display = 'none';
            markerDiv.style.transform = 'scale(0.7)';
          });
        }
      }

      const clusterIcon = {
        content: `<div style="cursor:pointer;width:58px;height:58px;background:#A595FF;border-radius:999px;display:flex;justify-content:center;align-items:center;" onmouseover="this.style.backgroundColor='#6C52FF';" onmouseout="this.style.backgroundColor='#A595FF';"></div>`,
        // size: (window as any).N.Size(40, 40),
        // anchor: (window as any).N.Point(20, 20),
      };

      markerClustering = new MarkerClustering({
        minClusterSize: 2,
        maxZoom: 21,
        map: map,
        markers: markers,
        disableClickZoom: false,
        gridSize: 120,
        icons: [clusterIcon],
        stylingFunction: function (clusterMarker, count) {
          const clusterMarkerDiv = clusterMarker.getElement().childNodes[0];
          clusterMarkerDiv.innerHTML = `<p style="color:#fff;font-size:18px;font-weight:700;">${count}</p>`;
        },
      });
    }

    return () => {
      markers.forEach(marker => {
        marker.setMap(null);
      });

      if (markerClustering) {
        markerClustering.setMap(null);
      }
    };
  }, [facilities, map]);
}
